/** Where an enemy's area attack will land: a red circle filling as its wind-up runs out. */
import { ellipse } from '../drawKit';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'telegraphs',
  layer: 'ground',
  order: 220,
  draw({ g, world: w, iso, ox, oy }) {
    g.lineWidth = 1;
    for (const tel of w.telegraphs) {
      const [x, y] = iso.proj(tel.x, tel.y);
      const rx = tel.radius * 22.6;
      const ry = tel.radius * 11.3;
      const k = tel.t / tel.life;
      g.fillStyle = 'rgba(190,20,40,.18)';
      ellipse(g, x + ox, y + oy, rx, ry);
      g.fill();
      g.strokeStyle = 'rgba(255,60,70,.85)';
      g.stroke();
      g.fillStyle = 'rgba(255,40,60,.35)';
      ellipse(g, x + ox, y + oy, rx * k, ry * k);
      g.fill();
    }
  },
});
